import React from 'react';
import { CssVarsProvider } from '@mui/joy/styles';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';
import { useNavigate } from 'react-router-dom';

export default function SeparatorBreadcrumbs({ items = [] }) {
  const navigate = useNavigate();

  if (!items || !Array.isArray(items)) {
    return null;
  }

  return (
    <CssVarsProvider>
      <Breadcrumbs separator="›" aria-label="breadcrumbs">
        {items.map((item, index) => {
          if (!item || typeof item !== 'object') return null;
          
          const isLast = index === items.length - 1;
          
          return isLast ? (
            <Typography key={item.label} color="neutral">
              {item.label}
            </Typography>
          ) : (
            <Link
              key={item.label}
              color="neutral"
              onClick={() => navigate(item.href)}
              sx={{ cursor: 'pointer' }}
            >
              {item.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </CssVarsProvider>
  );
}